import { WebPlugin } from '@capacitor/core';
export class ZebraPDAWeb extends WebPlugin {
    async openReader() {
        throw new Error('Method not implemented.');
    }
    async closeReader() {
        throw new Error('Method not implemented.');
    }
    async disconnect() {
        throw new Error('Method not implemented.');
    }
    async disposeReaders() {
        throw new Error('Method not implemented.');
    }
    async initRFID() {
        console.log("进入web.ts中执行初始化");
        return { isSuccess: false };
    }
    ;
}
//# sourceMappingURL=web.js.map